import { SingleSelectionValidator } from './single-selection';

export class EmailValidator extends SingleSelectionValidator {
  validateHelper({ data, configuration }) {
    const {
      selectedOption,
    } = data;

    const { options, isRequired } = configuration;

    if (selectedOption == null && isRequired) {
      return 'NoOptionSelected';
    }
    for (let i = 0; i < options.length; i += 1) {
      const {
        hasInput,
        key,
        maxLength,
      } = options[i];
      if (hasInput && key === selectedOption) {
        if (data[key] == null || data[key].length === 0) {
          return 'InputIsEmpty';
        } else if (key === 'yes') {
          if (!this.isEmail(data[key])) {
            return 'InvalidEmail';
          }
        } else if (maxLength && data[key] && data[key].length > maxLength) {
          return 'InputTooLong';
        }
      }
    }
    return null;
  }

  isEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validate({ data, configuration }) {
    return this.validateHelper({ data, configuration }) == null;
  }

  getError({ data, configuration, i18n }) {
    let error = {};
    const { options } = configuration;

    for (let i = 0; i < options.length; i += 1) {
      const {
        hasInput,
        key,
        maxLength,
      } = options[i];
      if (hasInput) {
        if (data[key] == null || data[key].length === 0) {
          error = {
            ...error,
            [key]: i18n.getString(_TL_('Please enter an email address')),
          };
        } else if (key === 'yes' && !this.isEmail(data[key])) {
          error = {
            ...error,
            [key]: i18n.getString(_TL_('Invalid email address')),
          };
        } else if (maxLength && data[key] && data[key].length > maxLength) {
          error = {
            ...error,
            [key]: i18n.getString(_TL_('Field should not exceed {{maxLength}} characters'), { maxLength }),
          };
        }
      }
    }
    return error;
  }

  isAnswered({ data, configuration, i18n }) {
    let error;
    const {
      selectedOption,
    } = data;
    const { isRequired } = configuration;

    if (selectedOption == null && isRequired) {
      error = i18n.getString(_TL_('Please answer this question'));
    }
    return error;
  }
}
